<template>
    <!-- 主容器 -->
    <div class="yx-div" style="">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>账单月份： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM" style="width:150px;margin-right: 15px;" type="month" placeholder="选择月" size="mini" /></div>
                    <!--
                    <el-button icon="el-icon-takeaway-box" size="mini" type="info" @click="settleDo">生成账单</el-button>
                    <el-button icon="el-icon-wallet" size="mini" type="success" @click="settleDoIn">确定入账</el-button>
                    -->


                </div>

                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div  style="margin-top: 20px">
                    检索条件：
                    <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                        <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                            <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-input>
                </div>
                <!--
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>账单月份： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM" style="width:150px;margin-right: 15px;" type="month" placeholder="选择月" size="mini" /></div>
                </div>
                -->
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                      :data="jnl"
                      border stripe
                      :header-cell-style="{background:'#f8f8f8'}"
                      v-loading="loading"
                      height="100%"
                      style="width: 100%">
                <el-table-column prop="name" label="服务商" width="200" show-overflow-tooltip />
                <el-table-column prop="month" align="center" width="120" label="月份" />
                <el-table-column prop="rewardAmount" align="right" width="200" label="分润金额" sortable />
                <!--
                <el-table-column prop="feeFix" align="center" width="100" label="手续费(元)" />
                <el-table-column prop="feeRate" align="center" width="100" label="税费(%)" />
                <el-table-column prop="settleAmount" align="right" width="150" label="实拨金额" sortable />
                -->
                <el-table-column prop="status" align="center" width="120" label="状态" >
                    <template slot-scope="scope">
                        <el-tag effect="dark" v-if="scope.row.status===0" type="info">未入账</el-tag>
                        <el-tag effect="dark" v-else type="success">已入账</el-tag>
                    </template>
                </el-table-column>
                <!--
                <el-table-column prop="orderNo" align="center" width="120" label="订单号" />
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button type="text"  size="mini" @click="viewDetail(scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
                -->

            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">
                {{msgInfo}}
            </div>
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        :page-size="10"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>



        <el-drawer
                :visible.sync="drawer"
                :show-close=false
                size = "50%"
                :with-header="false"
                direction="rtl">
            <div style="padding: 10px 10px 30px 10px">
                <span class="tipTitle-collapse">
                    收益合计
                    <span v-if="totalInfo.a1Id!==user.agentIdS" style="font-size:12px; font-weight: normal"> - <el-tag type="success" color="#FFFFFF">{{totalInfo.a1Name}}</el-tag> - <el-tag type="success" color="#FFFFFF">{{totalInfo.a1Rate}}%</el-tag></span>
                    </span>

                <el-table :data="[totalInfo]" v-if="mchs" >
                    <el-table-column label="收益类型" align="center">
                        {{totalInfo.a1Id===user.agentIdS?'直拓':'间推'}}
                    </el-table-column>
                    <el-table-column label="商户数" align="center">
                        {{mchs.length}}
                    </el-table-column>
                    <el-table-column prop="amount" label="交易额" align="center" />
                    <el-table-column prop="cnt" label="交易笔数" align="center" />
                    <el-table-column  :label="totalInfo.a1Id===user.agentIdS?'直拓收益':'间推收益'" align="center" >
                        <span style="color: blue; font-weight: bolder" v-if="totalInfo.a1Id===user.agentIdS">{{totalInfo.earning}}</span>
                        <span style="color: red; font-weight: bolder" v-else>{{totalInfo.earning}}</span>
                    </el-table-column>
                </el-table>
                <div style="height: 30px;"></div>
                <span class="tipTitle-collapse">
                    <span style="">商户汇总</span>
                </span>
                <div style="margin-top: 10px;">
                    <el-table :data="mchs" v-loading="loading2" size="mini" border stripe >
                        <el-table-column type="index" label="序号" align="center" />
                        <el-table-column prop="mchName" label="商户名称"  show-overflow-tooltip />
                        <el-table-column prop="cnt" label="交易笔数" align="center"  sortable width="100" />
                        <el-table-column prop="amount" label="交易额" align="right" sortable />
                        <el-table-column align="center" width="90" label="结算费率%">
                            <template slot-scope="scope">
                                <el-tag type="warning" color="#FFFFFF">{{scope.row.mchRate}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="totalInfo.a1Id===user.agentIdS?'直拓收益':'间推收益'" width="110" align="right">
                            <template slot-scope="scope">
                                <span style="color: blue; font-weight: bolder" v-if="scope.row.a1Id===user.agentIdS">{{scope.row.a1Earning}}</span>
                                <span style="color: red; font-weight: bolder" v-else-if="scope.row.a2Id===user.agentIdS">{{scope.row.a2Earning}}</span>
                                <span style="color: red; font-weight: bolder" v-else-if="scope.row.a3Id===user.agentIdS">{{scope.row.a3Earning}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页栏 -->
                    <div class="yx-flex-h-end">
                        <el-pagination small
                                       :page-size="size2"
                                       @current-change="currentChangeFA"
                                       @size-change="sizeChangeFA"
                                       layout="total, prev, pager, next"
                                       :total="total2">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </el-drawer>

    </div>

</template>

<script>
    export default {
        name: "BillRewardSettleList", //我的分润结算单
        data() {
            return {
                loading2: false,
                loading: false,
                showFV: false,
                msgInfo: null,
                total: 0,
                page: 1,
                size: 10,
                total2: 0,
                page2: 1,
                size2: 10,
                jnl: [],
                mchs: null,
                keywordList: [
//                    {id:"agentName",name:"服务商名称"},
                ],
                searchVal: {
                    type:'YSF',
                    keywordMethod: '',
                    keyword: '',
                    totalTypes : [],
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null
                },
                totalInfo:{

                },
                drawer: false
            }
        },
        computed: {
            user() {
                return this.$store.state.currentHr;
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                /*
                if(this.searchVal.type==='1') {
                    this.initJnl();
                }
                else {
                    this.jnl = [];
                    this.total = 0;
                }
                */
                this.initJnl();

            },
            viewDetail(row) {
                console.log(row)
                Object.assign(this.totalInfo, row);
                this.drawer = true;
                this.page2 = 1;
                this.size2 = 10;
                this.total2 = 0;
                this.initMch();
            },
            initMch() {
                this.loading2 = true;
                // let url = '/agent/agentRewardTotalMch?page=' + this.page2 + '&size=' + this.size2 + '&id=' + this.totalInfo.id;
                let url = '/rpt/agent/mch/rewardTotalsMch?page=' + this.page2 + '&size=' + this.size2 + '&id=' + this.totalInfo.a1Id;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                this.mchs = null
                this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp) {
                        this.mchs = resp.data;
                        this.total2 = resp.total;
                    }
                });
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/comp/agent/rewards/settleList?page=' + this.page + '&size=' + this.size + '&userId=' + this.user.agentIdS;
                /***/
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&month=' + this.searchVal.transDateScope;

                url = url + '&payChannelCode=' + this.searchVal.type;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo
                    }
                });
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            funFmtTransAmt1(row, column) {
                return row.totalAmt.toFixed(2);
            },
            funFmtTransAmt2(row, column) {
                return row.feeAmt.toFixed(2);
            },
            funFmtTransAmt3(row, column) {
                return row.rewardAmt.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChangeFA(currentSize) {
                this.size2 = currentSize;
                this.initMch();
            },
            currentChangeFA(currentPage) {
                this.page2 = currentPage;
                this.initMch();
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
            getModelNameById(id) {
                if(this.$root.g_data_dev_model!==null) {
                    for(let i=0;i<this.$root.g_data_dev_model.length;i++) {
                        if(id===''+this.$root.g_data_dev_model[i].id) {
                            return this.$root.g_data_dev_model[i].model;
                        }
                    }
                }
                return '';
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                if (!row.a2Id) {
                    if (columnIndex === 1) {
                        return [1, 2];
                    } else if (columnIndex === 2) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex % 2 === 0) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    switch (index) {
                        case 0:
                            sums[index] = '合计';
                            return;
                        case 1:
                        case 2:
                        case 4:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                            sums[index] = '';
                            return;
                    }

                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (index===3 || index===5) {
                            sums[index] = Number(sums[index]).toFixed(2) + ' 元';
                        }
                        else if (index===6) {
                            sums[index] = Number(sums[index]).toString() + ' 笔';
                        }
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                return sums;
            }
        }
    }
</script>

<style lang="less"  scoped>
    .cls-main-table {
        width: 100%;
        /**
        :deep(.el-table__header-wrapper) {
            thead {
                th{
                    div{
                        // font-weight: 700;
                        // font-size: 20px;
                    }
                }
            }
        }
        :deep(.el-table__body tr:hover > td){
            background-color: #00c0bc !important;
        }
        //表格内容颜色
        :deep(.el-table__body) {
            border-collapse: separate !important;
            // border-spacing: 0 15px !important;
            table-layout: auto !important;
        }
        :deep(.el-table,.el-table__expanded-cell) {
            background-color: transparent !important;
        }
        :deep(.el-table--enable-row-transition .el-table__body td,.el-table .cell) {
            background-color: transparent;
        }

        :deep(.el-table::before) {
            background-color: transparent;
        }
        :deep(.el-table__header tr),
        :deep(.el-table th, .el-table tr){
            background-color:transparent;
        }

        :deep( .el-table th>.cell){
            font-weight: 700;
            color: #fab969;
            font-size: 30px;
        }
        :deep(.el-table tbody tr td:nth-child(-n+2) div) {
            color: #d1bc8d;
        }
        :deep(.el-table tbody tr td div) {
            font-size: 32px;
        }

        :deep(.el-table__body) {
            border-collapse: separate !important;
            // border-spacing: 0 15px !important;
            table-layout: auto !important;
            tbody tr:nth-child(odd) {
                color: white;
                background-color: #282827;
            }
            tbody tr:nth-child(even) td {
                color: white;
                background-color: #3e3e3e;
            }
        }
        :deep( .el-table,.el-table__expanded-cell) {
            background-color: transparent !important;
        }
        :deep(.el-table--enable-row-transition .el-table__body td,.el-table .cell) {
            background-color: transparent;
        }

        :deep(.el-table__header tr),
        :deep( .el-table th, .el-table tr){
            background-color:transparent;
        }
        */
    }
</style>
